import Tippy from '@tippyjs/react';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-away-subtle.css';

import { ChevronRightIcon, ExclamationCircleIcon, LockClosedIcon, LockOpenIcon } from "@heroicons/react/solid";
import AccessControl from '../../../SharedComponents/AccessControl';
import { NO_ACCESS_TYPES, PERMISSIONS } from '../../../../utils/constants';

const DirectMenuItem = () => {
    return <Tippy
        content={
            <span>We strongly recommend editing permissions and applications using
                <span className={"font-semibold"}> User Group</span> rather than Direct assignments for each user.
            </span>
        }
        className={"p-2 shadow rounded-md text-amber-700 bg-amber-100 text-sm"}
        arrow={false}
        animation={"shift-away-subtle"}
    >
        <div>
            <ExclamationCircleIcon className={"block h-5 w-5 cursor-pointer text-amber-400"} />
        </div>
    </Tippy>;
}

function EditUserMenu(props) {
    const {
        user,
        editOption,
        handleEditOptionClick,
        showPermissionsTabs,
        showPermissionsDropDownTabs,
        handleShowPermissionsTabClick,
        showApplicationsTabs,
        showApplicationsDropDownTabs,
        handleShowApplicationsTabClick,
        showTagsTabs,
        showTagsDropDownTabs,
        handleShowTagsTabClick,
        loading
    } = props;

    return (
        <div className={"flex flex-row xl:flex-col gap-3 col-span-2 z-10 w-max xl:w-auto"}>
            <AccessControl requiredPermission={PERMISSIONS.UPDATE_USER_DETAILS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto  " +
                    "shadow-sm hover:text-secondary-600 transition transition-all cursor-pointer " +
                    (editOption === "Details" ? "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                    onClick={() => handleEditOptionClick("Details")}
                >
                    <span>Details</span>
                </div>
            </AccessControl>
            <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_PASSWORDS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto " +
                    "shadow-sm hover:text-secondary-600 transition transition-all cursor-pointer " +
                    (editOption === "Change password" ? "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                    onClick={() => handleEditOptionClick("Change password")}
                >
                    <span>Change password</span>
                </div>
            </AccessControl>
            <AccessControl requiredPermission={PERMISSIONS.MANAGE_USERS_IN_USER_GROUP} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto  " +
                    "shadow-sm hover:text-secondary-600 transition transition-all cursor-pointer " +
                    (editOption === "User Groups" ? "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                    onClick={() => handleEditOptionClick("User Groups")}
                >
                    <span>User Groups</span>
                </div>
            </AccessControl>
            <div className={
                "p-3 text-sm rounded-md grid grid-flow-row gap-4 font-medium relative w-max xl:w-auto  " +
                "shadow-sm hover:text-secondary-600 transition transition-height duration-300 cursor-pointer " +
                (editOption === "User Group Permissions" || editOption === "Direct Permissions" ?
                    "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                (showPermissionsTabs ? "xl:h-28 " : "xl:h-11 ") +
                (loading && "animate-pulse pointer-events-none")
            }
            >
                <div className={"flex item-center gap-2 justify-between w-full"}
                    onClick={handleShowPermissionsTabClick}
                >
                    <div>Permissions</div>
                    <ChevronRightIcon
                        className={
                            "block h-5 w-5 cursor-pointer transition transition-transform transform " +
                            (showPermissionsTabs && showPermissionsDropDownTabs && "rotate-90")
                        } />
                </div>

                {/*Desktop*/}
                <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_GROUP_PERMISSIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                    <div className={
                        "hidden xl:block text-sm rounded-md flex items-center justify-between font-medium " +
                        "hover:text-secondary-600 transition transition-all duration-100 cursor-pointer transform " +
                        (editOption === "User Group Permissions" ? "text-secondary-600 " : "text-blue-gray-600 ") +
                        (showPermissionsTabs ? "opacity-1 translate-y-0" : "opacity-0 -translate-y-4")

                    }
                        onClick={() => handleEditOptionClick("User Group Permissions")}
                    >
                        <span>User group</span>
                    </div>
                </AccessControl>
                <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_PERMISSIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                    <div className={
                        "hidden xl:block text-sm rounded-md flex items-center justify-between font-medium " +
                        "hover:text-secondary-600 transition transition-all duration-100 cursor-pointer transform " +
                        (editOption === "Direct Applications" ? "text-secondary-600 " : "text-blue-gray-600 ") +
                        (showPermissionsTabs ? "opacity-1 translate-y-0" : "opacity-0 -translate-y-4")
                    }
                        onClick={() => handleEditOptionClick("Direct Permissions")}
                    >

                        <div className={"flex items-center justify-between w-full"}>
                            <span>Direct</span>
                            <DirectMenuItem />
                        </div>
                    </div>
                </AccessControl>
                {/*Smaller Screens*/}
                {showPermissionsTabs && showPermissionsDropDownTabs &&
                    <div className={
                        "absolute xl:hidden top-4 right-0 p-3 text-sm rounded-md grid grid-flow-row gap-4 " +
                        "shadow-md bg-white mt-8 "
                    }>
                        <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_GROUP_PERMISSIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                            <div className={
                                "text-sm rounded-md flex items-center justify-between font-medium " +
                                "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                (editOption === "User Group Permissions" ? "text-secondary-600" : "text-blue-gray-600")
                            }
                                onClick={() => handleEditOptionClick("User Group Permissions")}
                            >
                                <span>User group</span>
                            </div>
                        </AccessControl>
                        <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_PERMISSIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                            <div className={
                                "text-sm rounded-md flex items-center justify-between font-medium " +
                                "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                (editOption === "Direct Permissions" ? "text-secondary-600" : "text-blue-gray-600")
                            }
                                onClick={() => handleEditOptionClick("Direct Permissions")}
                            >
                                <div className={"flex items-center justify-between w-full"}
                                    onClick={handleShowPermissionsTabClick}
                                >
                                    <span>Direct</span>
                                    <DirectMenuItem />
                                </div>
                            </div>
                        </AccessControl>
                    </div>
                }
            </div>
            <AccessControl requiredPermission={PERMISSIONS.VIEW_ORGANISATION_APPS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md grid grid-flow-row gap-4 font-medium relative w-max xl:w-auto  " +
                    "shadow-sm hover:text-secondary-600 transition transition-height duration-300 cursor-pointer " +
                    (editOption === "User Group Applications" || editOption === "Direct Applications" ?
                        "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (showApplicationsTabs ? "xl:h-28 " : "xl:h-11 ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                >
                    <div className={"flex item-center gap-2 justify-between w-full"}
                        onClick={handleShowApplicationsTabClick}
                    >
                        <div>Applications</div>
                        <ChevronRightIcon
                            className={
                                "block h-5 w-5 cursor-pointer transition transition-transform transform " +
                                (showApplicationsTabs && showApplicationsDropDownTabs && "rotate-90")
                            }
                        />
                    </div>

                    {/*Desktop*/}
                    <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_GROUP_APPLICATIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                        <div className={
                            "hidden xl:block text-sm rounded-md flex items-center justify-between font-medium " +
                            "hover:text-secondary-600 transition transition-all duration-200 cursor-pointer transform " +
                            (editOption === "User Group Applications" ? "text-secondary-600 " : "text-blue-gray-600 ") +
                            (showApplicationsTabs ? "opacity-1 translate-y-0" : "opacity-0 -translate-y-4")
                        }
                            onClick={() => handleEditOptionClick("User Group Applications")}
                        >
                            <span>User group</span>
                        </div>
                    </AccessControl>
                    <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_APPLICATIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                        <div className={
                            "hidden xl:block text-sm rounded-md flex items-center justify-between font-medium " +
                            "hover:text-secondary-600 transition transition-all duration-200 cursor-pointer transform  " +
                            (editOption === "Direct Applications" ? "text-secondary-600 " : "text-blue-gray-600 ") +
                            (showApplicationsTabs ? "opacity-1 translate-y-0" : "opacity-0 -translate-y-4")
                        }
                            onClick={() => handleEditOptionClick("Direct Applications")}
                        >
                            <div className={"flex item-center justify-between w-full"}>
                                <span>Direct</span>
                                <DirectMenuItem />
                            </div>
                        </div>
                    </AccessControl>

                    {/*Smaller Screens*/}
                    {showApplicationsTabs && showApplicationsDropDownTabs &&
                        <>
                            <div className={
                                "absolute xl:hidden top-4 right-0 p-3 text-sm rounded-md grid grid-flow-row gap-4 " +
                                "shadow-md bg-white mt-8 "

                            }>
                                <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_GROUP_APPLICATIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                                    <div className={
                                        "text-sm rounded-md flex items-center justify-between font-medium " +
                                        "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                        (editOption === "User Group Applications" ? "text-secondary-600" : "text-blue-gray-600")
                                    }
                                        onClick={() => handleEditOptionClick("User Group Applications")}
                                    >
                                        <span>User group</span>
                                    </div>
                                </AccessControl>
                                <AccessControl requiredPermission={PERMISSIONS.MANAGE_USER_APPLICATIONS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                                    <div className={
                                        "text-sm rounded-md flex items-center justify-between font-medium " +
                                        "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                        (editOption === "Direct Applications" ? "text-secondary-600" : "text-blue-gray-600")
                                    }
                                        onClick={() => handleEditOptionClick("Direct Applications")}
                                    >
                                        <div className={"flex item-center justify-between w-full"}>
                                            <span>Direct</span>
                                            <DirectMenuItem />
                                        </div>
                                    </div>
                                </AccessControl>
                            </div>
                        </>
                    }

                </div>
            </AccessControl>
            <AccessControl requiredPermission={PERMISSIONS.UPDATE_USER_DETAILS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md grid grid-flow-row gap-4 font-medium relative w-max xl:w-auto  " +
                    "shadow-sm hover:text-secondary-600 transition transition-height duration-300 cursor-pointer " +
                    (editOption === "User Group Tags" || editOption === "Direct Tags" ?
                        "text-secondary-600 bg-secondary-50 " : "text-blue-gray-600 bg-white ") +
                    (showTagsTabs ? "xl:h-28 " : "xl:h-11 ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                >
                    <div className={"flex item-center gap-2 justify-between w-full"}
                        onClick={handleShowTagsTabClick}
                    >
                        <div>Tags</div>
                        <ChevronRightIcon
                            className={
                                "block h-5 w-5 cursor-pointer transition transition-transform transform " +
                                (showTagsTabs && showTagsDropDownTabs && "rotate-90")
                            }
                        />
                    </div>

                    {/*Desktop*/}
                    <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_GROUP_TAGS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                        <div className={
                            "hidden xl:block text-sm rounded-md flex items-center justify-between font-medium " +
                            "hover:text-secondary-600 transition transition-all duration-200 cursor-pointer transform " +
                            (editOption === "User Group Tags" ? "text-secondary-600 " : "text-blue-gray-600 ") +
                            (showTagsTabs ? "opacity-1 translate-y-0" : "opacity-0 -translate-y-4")
                        }
                            onClick={() => handleEditOptionClick("User Group Tags")}
                        >
                            <span>User group</span>
                        </div>
                    </AccessControl>
                    <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_TAGS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                        <div className={
                            "text-sm rounded-md flex items-center justify-between font-medium " +
                            "hover:text-secondary-600 transition transition-all cursor-pointer " +
                            (editOption === "Direct Tags" ? "text-secondary-600" : "text-blue-gray-600")
                        }
                            onClick={() => handleEditOptionClick("Direct Tags")}
                        >
                            <div className={"flex item-center justify-between w-full"}>
                                <span>Direct</span>
                            </div>
                        </div>
                    </AccessControl>

                    {/*Smaller Screens*/}
                    {showTagsTabs && showTagsDropDownTabs &&
                        <>
                            <div className={
                                "absolute xl:hidden top-4 right-0 p-3 text-sm rounded-md grid grid-flow-row gap-4 " +
                                "shadow-md bg-white mt-8 "

                            }>
                                <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_GROUP_TAGS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                                    <div className={
                                        "text-sm rounded-md flex items-center justify-between font-medium " +
                                        "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                        (editOption === "User Group Tags" ? "text-secondary-600" : "text-blue-gray-600")
                                    }
                                        onClick={() => handleEditOptionClick("User Group Tags")}
                                    >
                                        <span>User group</span>
                                    </div>
                                </AccessControl>
                                <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_TAGS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                                    <div className={
                                        "text-sm rounded-md flex items-center justify-between font-medium " +
                                        "hover:text-secondary-600 transition transition-all cursor-pointer " +
                                        (editOption === "Direct Tags" ? "text-secondary-600" : "text-blue-gray-600")
                                    }
                                        onClick={() => handleEditOptionClick("Direct Tags")}
                                    >
                                        <div className={"flex item-center justify-between w-full"}>
                                            <span>Direct</span>
                                        </div>
                                    </div>
                                </AccessControl>
                            </div>
                        </>
                    }

                </div>
            </AccessControl>
            <AccessControl requiredPermission={PERMISSIONS.UNLOCK_USER_ACCOUNTS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <div className={
                    "p-3 text-sm rounded-md  flex items-center justify-between font-medium w-max xl:w-auto  " +
                    "shadow-sm transition transition-all cursor-pointer z-30 " +
                    (editOption === "Account" ? user && user.isLocked ? "text-red-600 bg-red-50 hover:text-red-600 " :
                        "text-secondary-600 bg-secondary-50 hover:text-secondary-600 " : "text-blue-gray-600 bg-white hover:text-secondary-600 ") +
                    (loading && "animate-pulse pointer-events-none")
                }
                    onClick={() => handleEditOptionClick("Account")}
                >
                    <div className={"flex items-center gap-2 justify-between w-full"}>
                        <div>Account</div>
                        {loading ?
                            <div className={"h-5 w-5 rounded-full bg-blue-gray-200 animate-pulse"}></div>
                            :
                            user && user.isLocked ?
                                <LockClosedIcon
                                    className={
                                        "block h-4 w-4 cursor-pointer text-red-600"
                                    } />
                                :
                                <LockOpenIcon
                                    className={
                                        "block h-4 w-4 cursor-pointer text-green-600"
                                    } />
                        }
                    </div>
                </div>
            </AccessControl>
        </div>

    );
}

export default EditUserMenu;